<script setup lang="ts">
const items = [
  {
    title: 'SLA Jelas & Terukur',
    description: 'Estimasi waktu penyelesaian sejak awal.',
    icon: 'material-symbols:timer-outline'
  },
  {
    title: 'Validasi Otomatis Resi & Data',
    description: 'Minim kesalahan manual.',
    icon: 'material-symbols:done-all'
  },
  {
    title: 'Pendampingan Tim CS 24/7',
    description: 'Bukan bot, tapi tim manusia yang sigap bantu.',
    icon: 'material-symbols:support-agent'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Keamanan Lebih, Kepercayaan Pelanggan Tetap Terjaga"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
